import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, PhoneCall } from 'lucide-react';

const CallToAction: React.FC = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-primary-800 to-primary-900 text-white">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Готовы обсудить ваш проект?</h2>
          <p className="text-xl text-primary-100 mb-8">
            Получите индивидуальное предложение по поставке трансформаторов и оборудования для
            вашего объекта
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/contact" className="btn-primary w-full sm:w-auto">
              <FileText className="mr-2 w-5 h-5" />
              Оставить заявку
            </Link>

            <a
              href="tel:+79137701139"
              className="btn bg-white text-primary-700 hover:bg-gray-100 w-full sm:w-auto"
            >
              <PhoneCall className="mr-2 w-5 h-5" />
              +7 (913) 770-11-39
            </a>
          </div>

          <p className="mt-6 text-primary-200 text-sm">
            Наши специалисты свяжутся с вами в течение 2 часов в рабочее время
          </p>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
